import React, { memo } from 'react'
import { Link } from "react-router-dom";

const NavigationCard = ({ cardItem, classes }) => {

  return (
      <div className={classes["card-wrapper"]}>
        <div className={classes["header"]}>
          {cardItem.logo && <img src={cardItem.logo} alt="card-logo"></img>}
          <h3>
            {cardItem.title}
          </h3>
        </div>

        <div className={classes["card-subtitle"]}>
          {cardItem.cardSubTitle}
        </div>
        <div className={classes["card-banner"]}>
          {cardItem.banner && (
            <img
              className={classes["card-banner-img"]}
              src={cardItem.banner}
              alt={cardItem.alt}
            ></img>
          )}
        </div>

        {cardItem.cardDesc && (
          <span className={classes["card-desc"]}>{cardItem.cardDesc}</span>
        )}
        <div className={classes["action-btn"]}>
          {cardItem.csr ? (
            <Link
              to={cardItem.redirectUrl}
              aria-label={`Navigate to ${cardItem?.title}`}
            >
              {cardItem.btnText}
            </Link>
          ) : (
            <a
              href={cardItem.redirectUrl}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Navigate to ${cardItem?.title}`}
            >
              {cardItem.btnText}
            </a>
          )}
        </div>
      </div>
  );
};

export default memo(NavigationCard);
